import { fetchData } from 'Utils/fetch-data';
import {
  CalificationI,
  LessonI,
  LessonQuestionI,
  TestConfigurationI,
  UserEvaluationAnswerI,
  UserEvaluationAnswerResponseI,
} from 'types';

class LessonApi {
  endpoint: string = '/lessons';

  /**
   * Obtiene una lección por su id.
   * @param lessonId - Id de la lección
   * @returns Lección
   */
  async getLesson(lessonId: string) {
    const response = await fetchData<LessonI>(`${this.endpoint}/${lessonId}`, {
      method: 'GET',
    });
    return response;
  }

  /**
   * Obtiene la configuración de una lección de tipo examen.
   *
   * @param lessonId - Id de la lección
   * @returns Configuración de la lección de examen
   */
  async getTestConfiguration(lessonId: string) {
    const response = await fetchData<TestConfigurationI>(`${this.endpoint}/${lessonId}/configuration`, {
      method: 'GET',
    });
    return response;
  }

  /**
   * Obtiene las preguntas de una lección de tipo `evaluación automática`.
   * @param lessonId - Id de la lección
   * @returns Preguntas de la lección
   */
  async getLessonQuestions(lessonId: string) {
    const response = await fetchData<LessonQuestionI[]>(`${this.endpoint}/${lessonId}/questions`, {
      method: 'GET',
    });
    return response;
  }

  /**
   * Envía las respuestas de una lección de tipo examen automático.
   * @see {@link test-start.js} Página de inicio del examen.
   *
   * @param data - Datos de la respuesta del empleado
   */
  async sendAnswers(data: UserEvaluationAnswerI) {
    const response = await fetchData<UserEvaluationAnswerResponseI>(`${this.endpoint}/answers`, {
      method: 'POST',
      data: JSON.stringify(data),
    });
    return response;
  }

  /**
   * Verifica si el usuario ya ha realizado el examen.
   * @param lessonId - Id de la lección
   * @returns Calificación del usuario o `null` si no ha realizado el examen
   */
  async checkIfUserHasAlreadyTakenTheTest(lessonId: string) {
    const response = await fetchData<CalificationI | null>(`${this.endpoint}/${lessonId}/already-answered`, {
      method: 'GET',
    });
    return response;
  }
}

const lessonApi = new LessonApi();

export default lessonApi;
